function submitForm($form) {
  const options = {
    data: $form.serialize(),
    method: $form.attr('method'),
  };

  $.ajax(window.location.href, options)
    .done(function(data) {
      $form.replaceWith(data);
    });
}

const ID_PREFIX = 'membership_request';

export default $ => {
  document.arrive(`#${ID_PREFIX}_sportingClub`, {existing: true}, function() {
    $(this).on('change', () => {
      submitForm($(this).closest('form'));
    });
  });

  document.arrive(`#${ID_PREFIX}_membershipOption`, {existing: true}, function() {
    $(this).on('change', () => {
      submitForm($(this).closest('form'));
    });
  });
}



// WEBPACK FOOTER //
// ./assets/js/scripts/membership-purchase-form.js